$ = require 'jquery'
CalendarCardView = require 'views/calendar/calendar-card-view'
Dates = require 'lib/dates'
DragSort = require 'views/lib/drag-sort'
View = require 'view'
_ = require 'underscore'
moment = require 'moment'

module.exports = class CalendarView extends View
  className: 'u-fancy-scrollbar calendar-drag-area'
  SCROLL_ANIMATION_TIME: 400

  initialize: ->
    listener = @listenToListChanges.bind(@)
    @model.listList.each listener
    @listenTo @model.listList, 'add remove', listener

  addedToDOM: ->
    if @model.editable()
      # Very slow, so defer it until after render finishes
      @defer ->
        DragSort.refreshCalendarCardSortable()

  delegateEvents: ->
    super
    dayView.delegateEvents() for dayView in @subviewsOfType(@DAY_VIEW_TYPE)

  setSubscriptions: ->
    throw new Error "CalendarView::setSubscriptions is an abstract method"

  stopSubscriptions: ->
    throw new Error "CalendarView::stopSubscriptions is an abstract method"

  listenToListChanges: (list) ->
    # Cards added to or removed from the list
    @listenTo list.cardList, 'add remove', (card) ->
      if @cardsWithDueDates([card]).length > 0
        dueDate = new Date(card.get('due'))
        @renderCardsOnDates([dueDate])

    # Cards changing due dates within the list
    @listenTo list.cardList, 'change:due', (card, newDueDate) ->
      oldDueStr = card.previousAttributes().due
      newDueStr = card.get('due')

      # new Date(undefined) == Invalid Date
      # new Date(null) == Epoch start
      oldDueDate = new Date(oldDueStr ? null)
      newDueDate = new Date(newDueStr ? null)

      if !moment(oldDueDate).isSame(newDueDate, 'day')
        dates = (new Date(dateStr) for dateStr in [oldDueStr, newDueStr] when dateStr?)
        @renderCardsOnDates(dates)

    # It would be ideal to listen to 'change:idList and change:closed', but
    # if we move a card to the Archive, it works, but when we move a card back to
    # a list from the archive, change:closed listener fires before the model gets
    # the new card, so @model.openCards() will not display the unarchived card,
    # we must unfortunately listen to reset.
    @listenTo list.cardList, 'reset', (cardList, prevObject) ->
      newList = cardList.models
      prevList = prevObject.previousModels
      difference = _.difference(newList, prevList).concat(_.difference(prevList, newList))
      @renderCardsOnDates(new Date(card.get('due')) for card in difference)

  navigateToday: -> @scrollToDay(@today, @SCROLL_ANIMATION_TIME)

  getCardView: (card) ->
    @subview(CalendarCardView, card, card.cid)

  cardsWithDueDates: (cards) ->
    cards.filter (card) -> card.get('due')?

  cardsDueOnDate: (cards, date) ->
    @cardsWithDueDates(cards).filter (card) ->
      moment(card.get('due')).isSame(date, 'day')

  cardSubviews: ->
    dayViews = @subviewsOfType(@DAY_VIEW_TYPE)
    cardViews =
      _.flatten(dayView.subviewsOfType(CalendarCardView) for dayView in dayViews)

  calculateFirstAndLastWeeksFromDOM: ->
    $weeks = @$('.week')
    @firstRenderedWeek = new Date(parseInt($weeks.first().attr('name')))
    @lastRenderedWeek = new Date(parseInt($weeks.last().attr('name')))
    @lastRenderedSaturday = Dates.getEndOfWeek(@lastRenderedWeek)

  renderCardsOnDates: (dates) ->
    # check that this view has been rendered and not just initialized
    if @$('.week').length > 0

      # Check that the date has been rendered
      for date in dates when @firstRenderedWeek < date < @lastRenderedSaturday
        cards = @cardsDueOnDate(@model.openCards(), date)
        dateInt = Dates.getMidnightInt(date)

        dayView = @existingSubview(@DAY_VIEW_TYPE, @model, dateInt)
        dayView.cardsDue = cards
        dayView.renderCardsAndHeaders()

  renderDayViews: (week) ->
    for day in week
      @getDayView(day).render().el

  getDayView: (day, options) ->
    data =
      day: day
      cardsDueOnDate: @cardsDueOnDate(@model.openCards(), day)

    @subview(
      @DAY_VIEW_TYPE,
      @model,
      _.extend({ data, getCardView: @getCardView.bind(@) }, options),
      Dates.getMidnightInt(day)
    )

  weekRowEl: (day) ->
    dayViews = @renderDayViews(Dates.getDaysOfWeek(day))
    $row = $(document.createElement(@WEEK_WRAPPER_ELEMENT))

    $row
      .attr('name', Dates.getMidnightInt(Dates.getStartOfWeek(day)))
      .addClass('week')
      .append(dayViews)
    return $row



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-view.coffee